import { atom } from 'nanostores';
import { persistentAtom } from '@nanostores/persistent';
import { syncPlayFolders } from './playFolders';
import { syncPlays } from './plays';
import {
  syncPlannerEvents,
  syncPlannerPlayers,
  syncPlannerTrainingTypes,
  syncPlannerCompetitionTypes,
} from './planner';

export enum TransitionMode {
  TIME_BASED = 'TIME_BASED',
  DISTANCE_BASED = 'DISTANCE_BASED',
}

// How piece drags are recorded on the tactic board: LINEAR keeps only the
// end position (classic behaviour), PATH also records the drag trail so
// playback can move the piece along it. Persisted: a coach's choice should
// survive reloads.
export enum MovementMode {
  LINEAR = 'LINEAR',
  PATH = 'PATH',
}
export const $isOnline = atom<boolean>(false);
export const $animationMode = atom<TransitionMode>(TransitionMode.TIME_BASED);
export const $movementMode = persistentAtom<MovementMode>(
  'movementMode',
  MovementMode.LINEAR,
);

const versionCheckUrl = process.env.REACT_APP_VERSION_CHECK_URL;
let intervalId: NodeJS.Timeout | undefined;
export function watchInternetIsAvailable() {
  pingVersionCheck().then((isOnline) => $isOnline.set(isOnline));
  startPinger();
  // window.addEventListener('online', () => {
  //   $isOnline.set(true)
  // })
  window.addEventListener('offline', () => {
    $isOnline.set(false);
  });
}

$isOnline.subscribe((isOnline, itWasOnline) => {
  if (isOnline !== itWasOnline) {
    if (!itWasOnline && isOnline) {
      // Came back online
      syncStores();
    }
  }
});

function syncStores() {
  void syncPlayFolders();
  void syncPlays();
  void syncPlannerEvents();
  void syncPlannerPlayers();
  void syncPlannerTrainingTypes();
  void syncPlannerCompetitionTypes();
}

export async function pingVersionCheck(): Promise<boolean> {
  const controller = new AbortController();
  const timeoutId = setTimeout(() => controller.abort(), 10000);
  try {
    const response = await fetch(versionCheckUrl as string, {
      method: 'GET',
      signal: controller.signal,
    });
    clearTimeout(timeoutId);
    return response.ok;
  } catch {
    clearTimeout(timeoutId);
    return false;
  }
}

function startPinger() {
  clearInterval(intervalId);
  intervalId = setInterval(async () => {
    const isOnline = await pingVersionCheck();
    $isOnline.set(isOnline);
  }, 10000);
}
